module.exports = __webpack_public_path__ + "img/_5.6a8a5591.png";